var map = {
	"./pages/admin/admin-pages/admin-pages.module.ngfactory": [
		"./src/app/pages/admin/admin-pages/admin-pages.module.ngfactory.js",
		"default~pages-admin-admin-pages-admin-pages-module-ngfactory~pages-client-client-pages-client-pages-~925c27df",
		"default~pages-admin-admin-pages-admin-pages-module-ngfactory~pages-provider-provider-pages-provider-~a5d138aa",
		"pages-admin-admin-pages-admin-pages-module-ngfactory"
	],
	"./pages/client/client-pages/client-pages.module.ngfactory": [
		"./src/app/pages/client/client-pages/client-pages.module.ngfactory.js",
		"default~pages-admin-admin-pages-admin-pages-module-ngfactory~pages-client-client-pages-client-pages-~925c27df",
		"default~pages-client-client-pages-client-pages-module-ngfactory~pages-provider-provider-pages-provid~9da088f3",
		"pages-client-client-pages-client-pages-module-ngfactory"
	],
	"./pages/provider/provider-pages/provider-pages.module.ngfactory": [
		"./src/app/pages/provider/provider-pages/provider-pages.module.ngfactory.js",
		"default~pages-admin-admin-pages-admin-pages-module-ngfactory~pages-client-client-pages-client-pages-~925c27df",
		"default~pages-client-client-pages-client-pages-module-ngfactory~pages-provider-provider-pages-provid~9da088f3",
		"default~pages-admin-admin-pages-admin-pages-module-ngfactory~pages-provider-provider-pages-provider-~a5d138aa",
		"pages-provider-provider-pages-provider-pages-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;